import { AiFillGoogleCircle } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/auth/google`;
const OAuth = () => {
  const dispatch = useDispatch();
  const loginWithGoogle = async () => {
    window.open("http://localhost:5000/auth/google/callback", "_self");
  };
  return (
    <div>
      <button
        type="button"
        className="--btn --btn-secondary --btn-block"
        onClick={loginWithGoogle}
      >
        <AiFillGoogleCircle size={20} style={{ marginRight: "10px" }} />
        Continue with Google
      </button>
    </div>
  );
};
export default OAuth;
